import { render, staticRenderFns } from "./Render.vue?vue&type=template&id=2634b5f0&scoped=true"
import script from "./Render.vue?vue&type=script&lang=js"
export * from "./Render.vue?vue&type=script&lang=js"
import style0 from "./Render.vue?vue&type=style&index=0&id=2634b5f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2634b5f0",
  null
  
)

export default component.exports